import Spec from '@Components/Shared/Specs/Spec';

const SpecList = (props) => {
    return (
        <div>
            <div className={props.RowClassName}>
                <span className='specs-title'>{props.GroupName}</span>
            </div>
            <div className='indent'>
                {Object.keys(props.Specs).map((key, index) =>
                    <Spec {...props.Specs[key]} key={key} RowClassName={props.RowClassName} />
                )}
            </div>
        </div>
    );
};

export default SpecList;